import React from "react";
import useSortingTable from "../useSortingTable";

const compare = (a, b) => {
	if (a > b) {
		return -1;
	}

	if (a < b) {
		return 1;
	}

	return 0;
};

// TODO: Remove hook and not use it for data ordering
const useSortingTableWithSortingData = ({
	columns,
	data,
	sortingKeys,
	sortingDefaults
}) => {
	const {
		sorting,
		columns: columnsWithSorting,
		toggleSorting
	} = useSortingTable({
		columns,
		sortingKeys,
		sortingDefaults
	});

	const mappedAndSortedData = React.useMemo(() => {
		if (!sorting) {
			return data;
		}

		return data.sort((a, b) => {
			const sortingDirection = sorting.direction === "DESC" ? 1 : -1;

			return (
				sortingDirection * compare(a[sorting.column], b[sorting.column])
			);
		});
	}, [data, sorting]);

	return {
		data: mappedAndSortedData,
		columns: columnsWithSorting,
		toggleSorting,
		sorting
	};
};

export default useSortingTableWithSortingData;
